import React from 'react';

export const DumpertLogoIcon = (props) => {
  return (
    <svg width='100%' viewBox='0 0 500 72.4' fill='currentColor' {...props}>
      <g>
        <polygon
          points='190.4,41.6 190.2,41.6 180.1,0 149.1,0 149.1,70.8 169.7,70.8 169.7,25.4 169.9,25.4 182.2,70.8
		198.5,70.8 210.8,25.4 210.9,25.4 210.9,70.8 231.6,70.8 231.6,0 200.5,0 	'
        />
        <path
          d='M119.3,38.5c0,7.2,0,16.3-10.3,16.3c-10.6,0-10.6-9-10.6-16.3V0H76.6v43.4c0,19.6,10.7,29,32.3,29
		c21.6,0,32.2-9.4,32.2-29V0h-21.8V38.5z'
        />
        <path
          d='M39.6,0H0v70.8h35.3C60,70.8,71.5,57,71.5,35.3C71.5,17.4,63.2,0,39.6,0z M20.6,54.9V16.5L54,35.7
		L20.6,54.9z'
        />
        <polygon
          points='327.2,43.8 360.6,43.8 360.6,27 327.2,27 327.2,18.1 363.9,18.1 363.9,0 305.4,0 305.4,70.8
		365,70.8 365,52.6 327.2,52.6 	'
        />
        <polygon points='438.6,0 438.6,18.1 458.4,18.1 458.4,70.8 480.2,70.8 480.2,18.1 500,18.1 500,0 	' />
        <path
          d='M426.1,38c7.2-2.7,10.6-10.4,10.6-17.7C436.7,6.8,426,0,413.6,0h-41.5v70.8h21.8V46.1h11.6
		c8.6,0,9.2,7,9.8,13.8c0.3,3.7,0.7,7.3,1.8,10.9h21.8c-2-3.3-2.1-11.7-2.4-15.2C435.7,46.8,432,40.2,426.1,38z M405.3,30.9h-11.4
		V16.8h10.2c8.3,0,10.8,2.6,10.8,7C414.9,30.2,409.4,30.9,405.3,30.9z'
        />
        <path
          d='M276.4,0H240v70.8h21.8V49.3h12.9c16.2,0,27.7-8,27.7-25.2C302.4,14.1,295.7,0,276.4,0z M270.2,32.5h-8.4
		V18.1h9.7c5.4,0,10.3,0.4,10.3,6.8C281.8,32.1,275.8,32.5,270.2,32.5z'
        />
      </g>
    </svg>
  );
};
